import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  changeTime: {
    id: 'alOrderSubForm.changeTime',
    defaultMessage: 'Muuta aika',
  },
  date: {
    id: 'alOrderSubForm.date',
    defaultMessage: 'Päivämäärä',
  },
  time: {
    id: 'alOrderSubForm.time',
    defaultMessage: 'Klo',
  },
  dateFrom: {
    id: 'alOrderSubForm.dateFrom',
    defaultMessage: 'Pvm alkaen',
  },
  dateUntil: {
    id: 'alOrderSubForm.dateUntil',
    defaultMessage: 'Pvm viimeistään',
  },
  timeFrom: {
    id: 'alOrderSubForm.timeFrom',
    defaultMessage: 'Alkaen klo',
  },
  timeUntil: {
    id: 'alOrderSubForm.timeUntil',
    defaultMessage: 'Viimeistään klo',
  },
  caseNumber: {
    id: 'alOrderSubForm.caseNumber',
    defaultMessage: 'Tilauksen viite',
  },
  billingInfo: {
    id: 'alOrderSubForm.billingInfo',
    defaultMessage: 'Laskutus',
  },
  personCount: {
    id: 'alOrderSubForm.personCount',
    defaultMessage: 'Henkilömäärä',
  },
  serviceChannel: {
    id: 'alOrderSubForm.serviceChannel',
    defaultMessage: 'Palvelukanava',
  },
  serviceType: {
    id: 'alOrderSubForm.serviceType',
    defaultMessage: 'Työn tyyppi',
  },
  additionalInfo: {
    id: 'alOrderSubForm.additionalInfo',
    defaultMessage: 'Työselvitys Autoliitolle',
  },
  notes: {
    id: 'alOrderSubForm.notes',
    defaultMessage: 'Muistiinpanot (sisäiseen käyttöön)',
  },
})
